import tmhRequest from '@/config/tmhRequest'


export default {

    searchInvoiceOrder: function (data) {
        return tmhRequest({
            url: '/finance/invoiceorder/searchinvoiceorder',
            method: 'post',
            params: data,
        })
    },

    searchPaymentCount: function (data) {
        return tmhRequest({
            url: '/finance/tmh/payment/searchpaymentcount',
            method: 'post',
            data: data,
        })
    },

    searchPaymentByPage: function (data) {
        return tmhRequest({
            url: '/finance/tmh/payment/searchpaymentbypage',
            method: 'post',
            data: data,
        })
    },

    repairPayment: function (data) {
        return tmhRequest({
            url: '/finance/tmh/payment/repairpayment',
            method: 'post',
            params: data,
        })
    },

    checkPayment: function (data) {
        return tmhRequest({
            url: '/finance/tmh/payment/checkpayment',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/finance/payment.js